/* eslint-disable no-useless-constructor */
import { TextAreaInput } from '../inputs';
import FieldModel from './FieldModel';

class MultiLineField extends FieldModel {
  /**
   * @param {Object} params
   * @param {string} params.kWord Unique object key (from plans)
   * @param {string} params.label Input label, used on the field filter
   * @param {boolean} [params.required] If the input is required (not empty)
   * @param {boolean} [params.removed] Condition to not render and use this field
   * @param {boolean} [params.disabled] Condition to block this field (still visible)
   * @param {any} [params.default] Default (initial) value
   * @param {number} params.min Minimum number of emails
   * @param {functtion} params.maxFunc Function to get the maximum number of emails
   */
  constructor(params) {
    super(params);
  }

  getDefaultState = () => ({
    value: '',
    formatedValue: [],
    error: Boolean(this.required),
    errorMsg: this.required ? 'Informe items válidos' : '',
  });

  // eslint-disable-next-line class-methods-use-this
  genFormatedState = (value) => (
    value ? {
      value: value.join('\n'),
      formatedValue: value.filter((t) => t),
      error: false,
      errorMsg: '',
    } : null
  );

  handleInput = (e, handle, state) => {
    const val = e.target.value;
    const items = val.split('\n').map((v) => v.trim());
    const max = this.maxFunc(state);
    let msg = '';
    if (items.length < this.min) {
      msg = `Informe pelo menos ${this.min} item${this.min > 1 ? 's' : ''}`;
    }
    if (items.length > max) {
      msg = `É permitido adicionar apenas ${max} item${max > 1 ? 's' : ''}`;
    }
    handle({
      [this.kWord]: {
        value: items.join('\n'),
        formatedValue: items.filter((t) => t),
        error: msg.length !== 0,
        errorMsg: msg,
      },
    });
  };

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (e) => this.handleInput(e, handle, state);
    return (
      <TextAreaInput
        label={this.label}
        placeholder="um item por linha..."
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
      />
    );
  };
}

export default MultiLineField;
